import React from "react";
import logoWebp from "@/assets/invisique-logo.webp";

/**
 * Invisique brand logo.
 *
 * Renders the official `Invisique_logo.webp` — a combined mark (teal
 * icon + navy wordmark with ™) with a **true alpha channel**, so it
 * drops cleanly onto any surface (white cards, off-white tints, glass
 * headers, gradients, or dark panels) without a visible background
 * rectangle.
 *
 * The asset was color-corrected to match the site palette exactly:
 *   • Icon teal  → `#007C9D` (Apollo Cyan-Teal, matches CTA buttons)
 *   • Wordmark   → `#002D39` (brand deep navy)
 *
 * Sizes tune image height (width auto to preserve the 3.5:1 aspect
 * ratio). Optional `showTagline` appends the brand tagline beneath
 * the mark — used in the site footer and printable PDF headers. The
 * `dark` prop currently only affects the tagline text color; a dark-
 * background variant of the mark itself will be shipped when the app
 * introduces its first dark surface.
 */
export const InvisiqueLogo = ({ showTagline = false, dark = false, size = "default" }) => {
    const heightClass =
        size === "lg" ? "h-12" :
        size === "sm" ? "h-7"  :
        "h-9";

    return (
        <div className="flex flex-col items-start gap-1.5" data-testid="invisique-logo">
            <img
                src={logoWebp}
                alt="Invisique"
                className={`${heightClass} w-auto select-none`}
                draggable={false}
            />
            {showTagline && (
                <div className={`text-[10px] tracking-[0.18em] uppercase font-semibold ${dark ? "text-white/70" : "text-muted-foreground"}`}>
                    Invisible Precision · Uniquely Yours
                </div>
            )}
        </div>
    );
};

export default InvisiqueLogo;
